<template>
  <div class="hpanel no-margins" :class="type === 'similar' ? 'panel-collapse' : ''">
    <template v-if="searchState">

      <list-news-results v-if="news" :context="context" v-model="news"
                              :nbEstimateNews="nbEstimateNews"
                              :nbNews="allNews.length"
                              :listType="listType" :changeSort="changeSort"
                              :biblioBoxes="biblioBoxes"/>

    </template>
    <template v-else>
      <template v-if="news.length === 0">
        <div class="panel-body">
          <div class="text-center">
            <h2 class="m-b-xs" v-if="type === 'selected'">Empty list – selected news</h2>
            <h2 class="m-b-xs" v-else-if="type === 'similar'">Empty list – similar news</h2>
            <div class="m">
              <i class="pe-7s-search fa-5x"></i>
            </div>
            <p class="small"></p>

            <router-link v-if="!$user.isBasic()" class="btn btn-info btn-sm" :to="{name: 'Search'}">Explore and fill list of news</router-link>
            <button v-else class="btn btn-info btn-sm" @click="context.showLimitPlan('explore')">Explore and fill list of news</button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="panel-heading hbuilt">

          <div class="row">
            <div class="col-xs-3">
              <template v-if="type === 'selected'">
                <h4>Selected News({{news.length}})</h4>
              </template>
              <template v-else-if="type === 'similar'">
                <h4>Similar News ({{news.length}})</h4>
              </template>
            </div>
            <div class="col-xs-8" style="height: 40px">
              <filters :type="listType" :workflow-id="2" :context="context"></filters>
            </div>
            <div class="col-xs-1">
              <div class="panel-tools m-t-xs">
                <a class="showhide" @click="showHidePanelList">
                  <i class="fa" :class="type === 'similar' ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </a>
              </div>
            </div>
          </div>

        </div>
      </template>
    </template>
  </div>
</template>

<script>

import Filters from './../filter/Filters'
import ListNewsResults from './ListNewsResults'

export default {
  components: {
    ListNewsResults,
    Filters
  },
  props: ['allNews', 'type', 'listId',
    'context',
    'biblio', 'nbEstimateNews', 'searchState', 'listType', 'searchType', 'project'],
  name: 'ListNews',
  data () {
    return {
      localAllNews: [],
      news: [],
      sort: {
        col: 'score',
        order: 'desc'
      }
    }
  },
  computed: {
    biblioBoxes: function () {
      let content = this.biblio && this.biblio.content ? JSON.parse(this.biblio.content) : {}
      let boxes = []
      Object.values(content).forEach((box) => {
        boxes.push({key: box.key, name: box.name})
      })
      boxes.sort(function (boxe1, boxe2) {
        if (boxe1.name.toUpperCase() < boxe2.name.toUpperCase()) return -1
        if (boxe1.name.toUpperCase() > boxe2.name.toUpperCase()) return 1
        return 0
      })
      return boxes
    }
  },
  watch: {
    'context.newsProviderSelected': function () {
      this.initNews()
    },
    'context.newsDateSelected': function () {
      this.initNews()
    },
    allNews: function (val) {
      this.localAllNews = val
    },
    localAllNews: function (val) {
      if (val.length !== 0 && this.listId !== null) {
        this.initNews()
      } else {
        this.news = []
      }
    },
    'biblio.content': function (content) {
      this.setSelectedNewsInBiblio()
    }

  },
  methods: {
    setSelectedNewsInBiblio: function () {
      if (this.biblio !== null && typeof this.biblio.content !== 'undefined') {
        let content = JSON.parse(this.biblio.content)
        let documentsId = {}
        documentsId = this.getNewsSelectedInBiblio(content)

        this.news.forEach((news) => {
          news.biblio = documentsId[news.hashId]
        })
      }
    },
    getNewsSelectedInBiblio: function (nodes) {
      let documentsId = {}

      for (let keyNode in nodes) {
        if (!nodes.hasOwnProperty(keyNode)) { continue }
        if (typeof nodes[keyNode]['documents'] !== 'undefined') {
          for (let documentKey in nodes[keyNode]['documents']) {
            if (!nodes[keyNode]['documents'].hasOwnProperty(documentKey)) { continue }
            documentsId[nodes[keyNode]['documents'][documentKey]['id']] = documentsId[nodes[keyNode]['documents'][documentKey]['id']] ? documentsId[nodes[keyNode]['documents'][documentKey]['id']] + ';' + keyNode : keyNode
          }
        }
      }
      return documentsId
    },
    initNews: function () {
      let news = Object.assign([], this.localAllNews)

      if (this.context.newsProviderSelected.length === 0 && this.context.newsDateSelected.length === 0) {
        this.context.filterSelected = null
      } else {
        if ((this.context.newsProviderSelected.length === 0 && this.context.filterSelected === 'newsProvider') ||
            (this.context.newsDateSelected.length === 0 && this.context.filterSelected === 'datePublished')) {
          this.context.filterSelected = null
        }

        this.initFilters(news)

        if (this.context.filterSelected === null) {
          if (this.context.newsProviderSelected.length > 0) {
            this.context.filterSelected = 'newsProvider'
          }
          if (this.context.newsDateSelected.length > 0) {
            this.context.filterSelected = 'datePublished'
          }
        }
      }
      news = this.applyFilters(news)

      if (news.length === 0) {
        this.resetFilters()
      }

      this.initFilters(news)

      news = this.applyFilters(news)

      this.applySort(news)
      this.identifySelectedAndSimilarCompanies(news)
      // TODO: to be checked
      let itemsToDisplay = news.find((item) => {
        return true // item.display === true
      })

      this.context.hasItemsToDisplay = (typeof itemsToDisplay !== 'undefined')
    },
    resetFilters: function () {
      this.context.filterSelected = null
      this.context.newsProviderSelected = []
      this.context.newsDateSelected = []
    },
    initFilters: function (news) {
      let newsProviderFilter = []
      let newsDateFilter = []

      news.forEach((row) => {
        let newsProvider = newsProviderFilter.find((element) => {
          return element.name === row.provider[0].name
        })

        if (typeof newsProvider === 'undefined') {
          newsProviderFilter.push({nb: 1, name: row.provider[0].name})
        } else {
          ++newsProvider.nb
        }
        newsProviderFilter.sort((provider1, provider2) => {
          return provider2.nb - provider1.nb
        })
        let date = new Date(row.datePublished).getFullYear()

        let year = newsDateFilter.find((element) => {
          return element.name === date
        })

        if (typeof year === 'undefined') {
          newsDateFilter.push({nb: 1, name: date})
        } else {
          ++year.nb
        }
      })

      if (this.context.filterSelected !== 'newsProvider' || this.context.newsProviderFilter.length === 0) {
        this.context.newsProviderFilter = newsProviderFilter
      }
      if (this.context.filterSelected !== 'datePublished' || this.context.newsDateFilter.length === 0) {
        this.context.newsDateFilter = newsDateFilter
      }

      if (this.context.filterSelected === null) {
        this.context.newsProviderFilter = newsProviderFilter
        this.context.newsDateFilter = newsDateFilter
      }
    },
    applyFilters: function (news) {
      if (this.context.filterSelected !== null) {
        if (this.context.newsProviderSelected.length > 0 || this.context.newsDateSelected.length > 0) {
          news = news.filter((row) => {
            let newsFilterByProvider = true
            let newsFilterByDatePublished = true

            this.context.newsProviderSelected.map((newsProvider) => {
              if (row.provider[0].name === newsProvider.name) {
                newsFilterByProvider = false
              }
            })

            this.context.newsDateSelected.map((datePublished) => {
              if (new Date(row.datePublished).getFullYear() === datePublished.name) {
                newsFilterByDatePublished = false
              }
            })

            let newsFilter = true
            if (newsFilterByProvider === false || newsFilterByDatePublished === false) {
              newsFilter = false
              if (this.context.newsProviderSelected.length > 0 && newsFilter === false) {
                newsFilter = newsFilterByProvider
              }
              if (this.context.newsDateSelected.length > 0 && newsFilter === false) {
                newsFilter = newsFilterByDatePublished
              }
            }
            return !newsFilter
          })
        }
      }
      return news
    },
    applySort: function (news) {
      switch (this.sort.col) {
        case 'score':
          news.sort((news1, news2) => {
            if (this.sort.order === 'desc') {
              return parseInt(news2.score) - parseInt(news1.score)
            } else if (this.sort.order === 'asc') {
              return parseInt(news1.score) - parseInt(news2.score)
            }
          })
          break
        case 'date':
          news.sort((news1, news2) => {
            if (this.sort.order === 'desc') {
              return new Date(news2.datePublished) - new Date(news1.datePublished)
            } else if (this.sort.order === 'asc') {
              return new Date(news1.datePublished) - new Date(news2.datePublished)
            }
          })
          break
        case 'title':
          news.sort((news1, news2) => {
            if (this.sort.order === 'desc') {
              return news2.name.toLowerCase() < news1.name.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return news1.name.toLowerCase() < news2.name.toLowerCase() ? -1 : 1
            }
          })
          break
        case 'provider':
          news.sort((news1, news2) => {
            let provider1 = news1.provider[0]
            let provider2 = news2.provider[0]

            if (this.sort.order === 'desc') {
              return provider2.name.toLowerCase() < provider1.name.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return provider1.name.toLowerCase() < provider2.name.toLowerCase() ? -1 : 1
            }
          })
          break
      }
    },
    identifySelectedAndSimilarCompanies: function (news) {
      this.news = Object.assign([], news)
      this.setSelectedNewsInBiblio()
    },
    filterByName: function (news) {
      news = news.filter((row) => {
        return row.lastName.toLowerCase() === this.searchType.lastName.toLowerCase()
      })
      return news
    },
    changeSort: function (col) {
      this.sort.col = col
      this.sort.order = (this.sort.order === 'desc' ? 'asc' : 'desc')
      this.applySort(this.news)
    },
    showHidePanelList: function (event) {
      event.preventDefault()
      let hpanel = $(this.$el).closest('div.hpanel')
      let icon = $(this.$el).find('i:first')
      let body = hpanel.find('div.panel-body:first')
      let footer = hpanel.find('div.panel-footer:first')

      body.slideToggle(300)
      footer.slideToggle(200)

      // Toggle icon from up to down
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
      hpanel.toggleClass('').toggleClass('panel-collapse')

      setTimeout(function () {
        hpanel.resize()
        hpanel.find('[id^=map-]').resize()
      }, 50)
    }
  },
  beforeMount () {
    this.localAllNews = this.allNews
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListNews/ListNews.vue